"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var Item_1 = require("@lsg/components/lib/components/atoms/List/Item");

var rich_text_types_1 = require("@contentful/rich-text-types");

exports.renderListItem = function (node, children) {
  console.log(node.nodeType, node.content);

  var _a = __read(node.content, 1),
      content = _a[0];

  if (content.nodeType === rich_text_types_1.BLOCKS.PARAGRAPH) {
    var _b = __read(children, 1),
        paragraphElement = _b[0];

    return paragraphElement && React.createElement(Item_1.Item, null, paragraphElement.props.children);
  }

  return React.createElement(Item_1.Item, null, children);
};